<template>
  <v-form
    ref="form"
    lazy-validation
  >
    <v-card>
      <v-card-title v-if="title">
        <span class="text-h3">{{ $t(title) }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              v-if="authUser.isAdmin"
              cols="12"
              sm="6"
            >
              <v-autocomplete
                v-model="options.product"
                dense
                :disabled="type == 'edit'"
                :items="['cso']"
                item-text="name"
                item-value="id"
                :label="$t('select_product_*')"
                :rules="[rules.required]"
                @change="tenantList"
              />
            </v-col>
            <v-col
              v-if="authUser.isAdmin"
              cols="6"
              sm="6"
            >
              <v-autocomplete
                v-model="options.tenant_id"
                dense
                :loading="tenantLoading"
                :items="
                  options.product
                    ? options.product == 'oem'
                      ? tenantsOEM
                      : tenantsCSO
                    : []
                "
                :disabled="type == 'edit'"
                item-text="name"
                item-value="id"
                :label="$t('select_tenant_*')"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="options.business_name"
                dense
                :label="$t('business_name_*')"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="options.contact_no"
                dense
                :label="$t('phone_number_*')"
                :rules="[rules.required, rules.phone, rules.startFrom(3)]"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="options.contact_email"
                dense
                :label="$t('email_*')"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-select
                v-model="options.status"
                dense
                :disabled="readOnly"
                :items="statusOptions"
                item-value="id"
                item-text="name"
                :label="$t('status_*')"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
            >
              <v-text-field
                v-model="options.address"
                dense
                :label="$t('address_*')"
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <small v-if="!readOnly">{{ $t("indicates_required_field") }}</small>
        <v-spacer />
        <v-btn
          color="red darken-1"
          text
          @click="closeForm()"
        >
          Close
        </v-btn>
        <v-btn
          v-if="!readOnly"
          color="primary"
          text
          :loading="loading"
          @click="saveItem"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import { validationRules } from "@/mixins/validationRules";
import { mapGetters } from "vuex";

export default {
  mixins: [validationRules],

  props: {
    type: {
      type: String,
      default() {
        return {
          time: null,
        };
      },
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    readOnly: {
      type: Boolean,
      default() {
        return false;
      },
    },
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tenantOEM: [],
      options: {},

      statusOptions: [
        {
          id: "true",
          name: "active",
        },
        {
          id: "false",
          name: "inactive",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      tenantLoading: "tenantsManagement/getIsLoading",
      tenantsList: "tenantsManagement/getTenantOptions",
      tenantsOEM: "tenantsManagement/getTenantsOEM",
      tenantsCSO: "tenantsManagement/getTenantsCSO",
      //
    }),
    title() {
      if (this.readOnly) {
        return "view";
      }
      if (this.type == "create") {
        return "add_new";
      } else if (this.type == "edit") {
        return "edit";
      } else {
        return "";
      }
    },
  },
  watch: {
    "options.tenant_id": {
      handler: async function (val) {
        if (this.type == "create") this.fetchDependents(val);
      },
    },
  },
  async beforeMount() {
    if (this.type == "create") {
      if (!this.authUser.isAdmin) {
        this.options.tenant_id = this.authUser.tenant_id;
        this.fetchDependents(this.authUser.tenant_id);
      }
      // this.options.currency = "PKR";
    }

    if (this.type == "edit") {
      this.options = { ...this.item };
      this.options.product = "cso";
      this.options.tenant_id = this.options.tenant;
      this.options.status = this.options.status ? "true" : "false";

      // await this.$store
      //   .dispatch("csmsLocations/list", {
      //     tenant_id: this.options.tenant_id,
      //   })
      //   .then(() => {
      //     if (this.options.location_id) {
      //       const arr = this.locationsList.find(
      //         (r) => r.id == this.options.location_id
      //       );
      //       this.options.latitude = arr?.latitude;
      //       this.options.longitude = arr?.longitude;
      //     }
      //   });
      // await this.$store.dispatch("csmsRates/list", {
      //   tenant_id: this.options.tenant_id,
      // });
    }
  },
  methods: {
    tenantList() {
      if (this.product == "oem") {
        this.tenantOEM = this.tenantsList.filter((r) => r.product == "oem");
      } else {
        this.tenantOEM = this.tenantsList.filter((r) => r.product == "cso");
      }
    },
    saveItem() {
      if (this.$refs.form.validate()) {
        const opt = { ...this.options };
        this.$emit("onsave", opt);
      }
    },
    closeForm() {
      // this.$refs.form.reset();
      this.$emit("onclose");
    },

    async fetchDependents() {
      // delete this.options.location_id;
      // delete this.options.latitude;
      // delete this.options.longitude;
      // await this.$store
      //   .dispatch("csmsLocations/list", {
      //     tenant_id: tId,
      //   })
      //   .then(() => {
      //     if (this.options.location_id) {
      //       const arr = this.locationsList.find(
      //         (r) => r.id == this.options.location_id
      //       );
      //       this.options.latitude = arr?.latitude;
      //       this.options.longitude = arr?.longitude;
      //     }
      //   });
      // await this.$store.dispatch("csmsLocations/list", { tenant_id: tId });
      // await this.$store.dispatch("csmsRates/list", { tenant_id: tId });
    },

    //
  },
};
</script>
<style lang="sass" scoped>
.connectorsRow

  display: flex
  gap:1rem
  .field
    min-width:150px !important
    max-width:165px !important


.deleteButton
  cursor: pointer
  .deleteIcon
    &:hover
      color: red
</style>
